/**
 * TermsPage - Renders Terms of Service from `terms.md` (verbatim from MVC view).
 */

import termsContent from '@/content/legal/terms.md';
import { NS } from '@/i18n/namespaces';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from '../shared/LegalPageLayout';
import { MarkdownRenderer } from '../shared/markdown-renderer';

export const TermsPage: React.FC = () => {
  const { t } = useTranslation(NS.COMMON);
  const title = t('Terms_PageTitle', 'Terms of Service');

  useEffect(() => {
    if (typeof document !== 'undefined') document.title = `${title} – ECGrid`;
  }, [title]);

  return (
    <LegalPageLayout lastUpdated="2025-07-01">
      <MarkdownRenderer content={termsContent as unknown as string} />
    </LegalPageLayout>
  );
};

TermsPage.displayName = 'TermsPage';

export default TermsPage;
